<script lang="ts">
    import { formatCurrency } from '$lib/util/currencyUtil.js';
    import { useShopContext } from '$lib/context';
    import { number, t } from 'svelte-i18n';
    import type { ApiSchemas } from '$lib/api/shopwareApi';

    const shopContext = useShopContext();

    export let cart: ApiSchemas['Cart'];

    let priceForFreeDelivery = 280;
</script>

<div class="flex-col flex gap-2">
    <div class="flex justify-between text-primary">
        <p>{formatCurrency($number, shopContext.storeContext, cart.price.positionPrice)}</p>
        <p>{formatCurrency($number, shopContext.storeContext, priceForFreeDelivery)}</p>
    </div>
    <progress
        class="progress progress-primary w-full h-4 bg-primary/25 rounded-none"
        value={cart.price.positionPrice}
        max={priceForFreeDelivery}
    ></progress>
    {#if cart.price.positionPrice <= priceForFreeDelivery}
        <p class="text-neutral-500 text-sm">
            {$t('shop.cart.free-delivery-begin')}
            {formatCurrency($number, shopContext.storeContext, priceForFreeDelivery - cart.price.positionPrice)}
            {$t('shop.cart.free-delivery-end')}
        </p>
    {:else}
        <p class="text-neutral-500 text-sm">{$t('shop.cart.free-delivery-achieved')}</p>
    {/if}
</div>
